import Chip from "@mui/material/Chip";

export const FreeChip = () => <Chip label={"Free"} size={"small"} color={"success"}/>